import { useSelector } from 'react-redux';
import { vipLevelArray } from 'shared/constants/common';
import { State } from 'shared/interface';

export const useVipUserCheck = () => {
	const vipData = useSelector<State, number>((state) => state.login.vipLevel);
	const isVip = Array.isArray(vipData) && vipData.length === 0 ? false : true;

	const vipRank = vipLevelArray[vipData];

	const vipUserBgClassMap = new Map<number, string>([
		[0, 'silver-bg'],
		[1, 'yellow-bg'],
		[2, 'yellow-bg'],
		[3, 'yellow-bg'],
		[4, 'green-bg'],
		[5, 'blue-bg'],
	]);

	const vipUserInitalsBgClass = isVip ? vipUserBgClassMap.get(vipRank) : '';

	return { vipData, isVip, vipLevelArray, vipUserInitalsBgClass, vipRank };
};
